export default "__VITE_ASSET__CzFRp13$__"